export default "__VITE_ASSET__302504ad__"